import { Component, inject, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { SnackBarErrorData } from 'src/app/model/af.model';

@Component({
  selector: 'app-error-message',
  standalone: true,
  imports: [],
  templateUrl: './error-message.component.html',
  styleUrl: './error-message.component.scss'
})
export class ErrorMessageComponent {
  snackBarRef = inject(MatSnackBarRef);

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackBarErrorData) {
    // Screen reader doesn't pronounce the action label correctly if the message doesn't end with '.', so appending it if the message
    // doesn't have one
    if (data && data.errorMsg && data.errorMsg.trim().slice(-1) !== ".") {
      data.errorMsg = data.errorMsg.trim() + ".";
    }
  }
}
